/**
 * DIE FEHLERABLAGE (ERR-07, ERR-10) — der Vertrag zwischen API und Maske.
 *
 * "Dauerhaft gescheiterte Vorgänge landen in einer Fehlerablage mit
 * vollständigem Kontext und sind nach Behebung der Ursache erneut auslösbar,
 * ohne Neuerfassung."
 *
 * OHNE JEDE EINFUHR: Das Web bindet die Datei über den Quellpfad ein
 * (`@crm/kontrakte/src/fehlerablage`), weil eine Werteinfuhr aus dem Paket zod
 * in das Bündel zöge. Die API nimmt sie über das Paket.
 */

/** Wo der Vorgang gescheitert ist — abschließend nach 0120 und 0345. */
export type Fehlerbereich =
  | 'navision'
  | 'erechnung'
  | 'postausgang'
  | 'buchung'
  | 'zahlung'
  | 'belegausgabe'
  /* ERR-10 (0345): ein Hintergrundlauf scheitert in Folge. */
  | 'hintergrundlauf';

export const FEHLERBEREICHE: readonly Fehlerbereich[] = [
  'navision',
  'erechnung',
  'postausgang',
  'buchung',
  'zahlung',
  'belegausgabe',
  'hintergrundlauf',
] as const;

export type Fehlerzustand = 'offen' | 'erledigt' | 'verworfen';

export const FEHLERZUSTAENDE: readonly Fehlerzustand[] = ['offen', 'erledigt', 'verworfen'] as const;

export type Fehlerzeile = {
  readonly id: string;
  readonly bereich: Fehlerbereich;
  /** Die Zeile im Ursprungsbereich — der Anker für die Wiederholung. */
  readonly quelle: string;
  readonly belegart: string | null;
  readonly beleg: string | null;
  readonly zusammenfassung: string;
  /** ERR-07: der vollständige Kontext, ohne Geheimnisse (ERR-12). */
  readonly kontext: Record<string, unknown>;
  readonly versuche: number;
  /** ERR-10: einer der vier kritischen Fehler? */
  readonly kritisch: boolean;
  readonly zustaendigeRolle: string | null;
  readonly zustand: Fehlerzustand;
  readonly erledigtAm: string | null;
  readonly erledigtVon: string | null;
  readonly erledigtName: string | null;
  readonly erledigtGrund: string | null;
  readonly entstandenAm: string;
  readonly zuletztAm: string;
};
